import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, { useCallback, ChangeEvent } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { pinUserToSystems } from '../../../stores/actions/installerActions';
import { getVisibleSystemsForAccountShort } from  '../../../stores/actions/accountActions';
import { connect } from 'react-redux';
import Loading from '../../../components/Loading/Loading';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import Person from '@material-ui/icons/Person';
import utils from '../../../helpers/GlobalVariables';
import { Account, ISystem } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import _ from 'lodash';
import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import '../InstallerPanel.css';
import { FormLabel } from '@material-ui/core';

interface IPinUserProps {
    accounts: Account[];
    account: Account;
    classes: ClassNameMap;
    pinAccountFailed: boolean;
    pinAccountSucceeded: boolean;
    createAccountSucceeded: boolean;
    disableCreateAccountButton: boolean;
    disableRefreshButton: boolean;
    emptySystem: boolean;
    mobileView: boolean;
    pinUserToSystems: (accID, systemIDs, accType, notifs, skipNotifications?: boolean) => void;
    getVisibleSystemsForAccountShort: (accID) => void;
    systems: ISystem[];
    accountCategory: string;
}

const PinUser = ({
    accounts,
    pinAccountFailed,
    pinAccountSucceeded,
    createAccountSucceeded,
    disableCreateAccountButton,
    disableRefreshButton,
    emptySystem,
    mobileView,
    pinUserToSystems,
    getVisibleSystemsForAccountShort,
    systems,
    account,
    accountCategory,
    ...props
}: IPinUserProps) => {
    const { classes } = props;
    
    const getStyles = (name, personName, theme) => {
        return {
            fontWeight:
                personName.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    };
    const notificationGroups = ['System', 'Heartbeat', 'L1', 'L2', 'L3', 'L4', 'Obstruction'];
    const [error, setError] = useState<boolean>(false)
	const [pickedSystems, setPickedSystems] = useState<number[]|null[]|undefined>([]);
    const [pickedAccount, setPickedAccount] = useState<string>("");
    const [pickedAccountType, setPickedAccountType] = useState<string>("common_user")
    const [emailNotifs, setEmailNotifs] = useState({});
    const [pushNotifs, setPushNotifs] = useState({});
    const [smsNotifs, setSmsNotifs] = useState({});
    const [accountRoles, setAccountRoles] = useState({});
    const dispatch = useDispatch();
    const closeNotificationTimer = useRef(null);
    const [emptySystemError, setEmptySystemError] = useState<boolean>(false);
    const systemIds = systems.map(el => el.ID);
    const [systemOptions, setSystemOptions] = useState(systemIds);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name])); 
    const accountOptions = accounts
        .filter((account) => account.accountCategory === "commoner")
        .sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
        .map((account) => `${account.name} (${account.email})`);
        
    console.log('PinUser, systems', systems);
    const closePinAccountNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_PIN_ACCOUNT_NOTIFICATION });
    }, [dispatch]);

    useEffect(() => {
        closePinAccountNotification();
        setEmptySystemError(false);
    }, [closePinAccountNotification, setEmptySystemError]);

    useEffect(() => {
        if (pickedAccount) {
            const account = accounts.filter((acc) => acc.email === pickedAccount.split("(")[1].split(")")[0])[0];
            if (!account) {
                setPickedSystems([]);
                setPickedAccount("");
            }     
            const systemsDetails = account?.systemsDetails;
            if (systemsDetails) {
                const pinnedSystemsIds = systemsDetails.map(el => el.ID);
                const unpinnedSystemsIds = _.filter(systemIds, function (id) { return !pinnedSystemsIds.includes(id)});
                setPickedSystems([]);
                setSystemOptions(unpinnedSystemsIds);
            }

        }
    }, [accounts, pinAccountSucceeded]);

    useEffect(() => {
        let roles = {};
        pickedSystems?.forEach(sys => {
            roles[sys] = accountRoles[sys] ?? 'common_user';
        });
        setAccountRoles(roles);
    }, [pickedSystems]);


    useEffect(() => {
        if (pickedAccount) {
            const account = accounts.filter((acc) => acc.email === pickedAccount.split("(")[1].split(")")[0])[0];
            getVisibleSystemsForAccountShort(account.id);
            setEmailNotifs({});
            setPushNotifs({});
            setSmsNotifs({});
            setAccountRoles({});
        }
    }, [getVisibleSystemsForAccountShort, pickedAccount, pinAccountSucceeded]);

    useEffect(() => {
        if (pinAccountFailed || pinAccountSucceeded) {
            closeNotificationTimer.current = setTimeout(closePinAccountNotification, 6000);
        }
        if (emptySystemError) {
            closeNotificationTimer.current = setTimeout(() => {
                setEmptySystemError(false);
            }, 6000);
        }
        return () => {
            clearTimeout(closeNotificationTimer.current);
        };
    }, [closePinAccountNotification, pinAccountFailed, pinAccountSucceeded, emptySystemError]);

    const theme = useTheme();
    const handlePickAccount = (e: ChangeEvent<{ value: unknown }>, selected: string): void => {
        if (selected !== null && selected !== "") {
            setPickedAccount(selected);
        } else {
            setPickedAccount("")
        }
    };

    const pickedAccountObj = pickedAccount ? accounts.filter((acc) => acc.email === pickedAccount.split("(")[1]?.split(")")[0])[0] : null;
    const notificationsLocked = accountCategory === 'commoner'
        && !!pickedAccountObj?.systemsDetails?.some((s) => s.accountRole === 'administrator');

    const handlePinUserToSystem = (): void => {
        if (pickedAccount !== "" && pickedSystems?.length) {
            const accID = accounts.filter((acc) => acc.email === pickedAccount.split("(")[1].split(")")[0])[0].id;
            const accType = pickedAccountType;
            pinUserToSystems(accID, pickedSystems, accountRoles, {email: emailNotifs, push: pushNotifs, sms: smsNotifs}, notificationsLocked)
        }
    }

    const pinButton = (): JSX.Element => {
        if (disableCreateAccountButton) {
            return (
                <div style={{ marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
                    <Loading transform={1} height={17} width={40} color='darkGray' />
                </div>
            );
        }
        return (
            <Button
                size='medium'
                style={{ marginTop: error ? '5px' : '25px', transition: 'color 0.3s' }}
                disabled={pickedAccount === "" || !pickedSystems?.length}
                data-testid='pinUserToSystem'
                onClick={(e) => { handlePinUserToSystem() }}
            >
                Pin
            </Button>
        );
    };

    const renderMobileNotifications = (): JSX.Element => {
        const error = pinAccountFailed || emptySystemError;
        const headerStyle = utils.getHeaderStyle(error);

        if (!mobileView) return null;
        if (error || pinAccountSucceeded) {
            const className = error ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
            return (
                <h5 className={className} style={headerStyle}>
                    {pinAccountFailed
                        ? "Account can't be pinned to this system."
                        : 'Account pinned to the system.'}
                </h5>
            );
        }
        return <div style={utils.emptyHeaderStyle}></div>;
    };

    const renderNotificationSettings = () => {
        if (!pickedSystems?.length || !pickedAccount ) return null;
        if (notificationsLocked) {
            return (<div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', marginBottom: '20px' }}>
                <FormLabel style={{marginBottom: '15px', marginTop: '15px'}}>{'Notifications'}</FormLabel>
                <div style={{ color: 'grey' }}>You don't have permission to change this user's notification settings.</div>
            </div>);
        }

        const pickedSystemObjs = _.filter(systems, function (s) { return pickedSystems.includes(s.ID)});
        return (<div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', marginBottom: '20px' }}>
            <FormLabel style={{marginBottom: '15px', marginTop: '15px'}}>{'Notifications'}</FormLabel>
            { 
                pickedSystemObjs.map(sys => {
                    if (sys.systemVersion == 'W2') {
                        return  (
                        <div key={sys.ID} style={{ display: 'flex', alignItems: 'baseline' }}>                        
                            <div style={{ display: 'flex', flexDirection: mobileView ? 'column' : 'row', marginTop: mobileView ? '25px' : '0px', alignItems: 'baseline' }}>
                            <div style={{display: 'flex', width: mobileView ? '100%' : '300px'}}>{systemNamesByIds[sys.ID]}</div>
                              <div style={{display: 'flex', color: 'grey', marginTop: '16px'}}> W2 System can't be edited here. Go to the W2 System Settings panel. </div>
                            </div>
                        </div>)
                    }
                    return (
                    <div key={sys.ID} style={{ display: 'flex', alignItems: 'baseline' }}>
                        
                        <div style={{ display: 'flex', flexDirection: mobileView ? 'column' : 'row', marginTop: mobileView ? '25px' : '0px', alignItems: 'baseline', width: '100%' }}>
                        <div style={{display: 'flex', width: mobileView ? '100%' : '300px'}}>{systemNamesByIds[sys.ID]}</div>
                        <FormControl id='push-multi-chip-label' style={{minWidth: mobileView ? '10px' : '25%'}}>
                            <InputLabel id='push-multi-chip-label'>Email</InputLabel>
                            <Select
                                label='email-multi-chip-label-'
                                id='email-multi-chip'
                                multiple
                                // style={{maxWidth: mobileView ? '10px' : '250px', minWidth: mobileView ? '10px' : '50%'}}
                                value={emailNotifs[sys.ID] ?? []}
                                onChange={(e) => {
                                    setEmailNotifs(prevNotifs => {
                                        const newNotifs = { ...prevNotifs, [sys.ID]: e.target.value };
                                        return newNotifs;
                                    });
                                }}
                                input={<Input id='select-multiple-chip-' />}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {(selected as string[]).map((value) => (
                                            <Chip key={value} label={value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}
                            >
                                {notificationGroups.map((name, i) => (
                                    <MenuItem
                                        key={`name-${i}`}
                                        value={name}
                                        style={getStyles(name, 'email', theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl id='push-multi-chip-label2' style={{minWidth: mobileView ? '10px' : '25%', marginLeft: mobileView ? '0px' : '10px'}}>
                            <InputLabel id='push-multi-chip-label2'>Push</InputLabel>
                            <Select
                                label='push-multi-chip-label-'
                                id='push-multi-chip'
                                multiple
                                // style={{marginLeft: mobileView ? '0px' : '10px'}}
                                value={pushNotifs[sys.ID] ?? []}
                                disabled={sys.systemVersion == 'W2'}
                                onChange={(e) => {
                                    setPushNotifs(prevNotifs => {
                                        const newNotifs = { ...prevNotifs, [sys.ID]: e.target.value };
                                        return newNotifs;
                                    });
                                }}
                                input={<Input id='select-multiple-chip-2' />}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {(selected as string[]).map((value) => (
                                            <Chip key={value} label={value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}
                            >
                                {notificationGroups.map((name, i) => (
                                    <MenuItem
                                        key={`name-${i}`}
                                        value={name}
                                        style={getStyles(name, 'push', theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl id='sms-multi-chip-label2' style={{minWidth: mobileView ? '10px' : '25%', marginLeft: mobileView ? '0px' : '10px'}}>
                            <InputLabel id='sms-multi-chip-label2'>SMS</InputLabel>
                            <Select
                                label='sms-multi-chip-label-'
                                id='sms-multi-chip'
                                multiple
                                value={smsNotifs[sys.ID] ?? []}
                                disabled={sys.systemVersion == 'W2'}
                                onChange={(e) => {
                                    setSmsNotifs(prevNotifs => {
                                        const newNotifs = { ...prevNotifs, [sys.ID]: e.target.value };
                                        return newNotifs;
                                    });
                                }}
                                input={<Input id='select-multiple-chip-2' />}
                                renderValue={(selected) => (
                                    <div className={classes.chips}>
                                        {(selected as string[]).map((value) => (
                                            <Chip key={value} label={value} className={classes.chip} />
                                        ))}
                                    </div>
                                )}
                            >
                                {notificationGroups.map((name, i) => (
                                    <MenuItem
                                        key={`name-${i}`}
                                        value={name}
                                        style={getStyles(name, 'sms', theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        </div>
                    </div>
                    )
                })
            }
        
        </div>)
    }

    const renderAccountRoleSettings = () => {
        if (!pickedSystems?.length || !pickedAccount || accountCategory == 'commoner') return null;

        const pickedSystemObjs = _.filter(systems, function (s) { return pickedSystems.includes(s.ID)});
        return (<div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px', marginBottom: '20px', minWidth: mobileView ? '10px' : '25%' }}>
            <FormLabel style={{marginBottom: '15px', marginTop: '15px'}}>{'Account type'}</FormLabel>
            { 
                pickedSystemObjs.map(sys => {
                    return (
                    <div key={sys.ID} style={{ display: 'flex', alignItems: 'baseline' }}>
                        
                        <div style={{ display: 'flex', flexDirection: mobileView ? 'column' : 'row', marginTop: mobileView ? '25px' : '0px', alignItems: 'baseline' }}>
                        <div style={{display: 'flex', width: mobileView ? '100%' : '300px'}}>{systemNamesByIds[sys.ID]}</div>
                        <RadioGroup
                            row
                            aria-labelledby="demo-form-control-label-placement"
                            name="position"
                            defaultValue="common_user"
                        >

                            <FormControlLabel
                                value="common_user"
                                control={<Radio onChange={(e) => {
                                    setAccountRoles(prevRoles => {
                                        const newRoles = { ...prevRoles, [sys.ID]: e.target.value };
                                        return newRoles;
                                    });
                                }} />}
                                label="User"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="administrator"
                                control={<Radio onChange={(e) => {
                                    setAccountRoles(prevRoles => {
                                        const newRoles = { ...prevRoles, [sys.ID]: e.target.value };
                                        return newRoles;
                                    });
                                }} />}
                                label="Admin"
                                labelPlacement="start"
                            />

                        </RadioGroup>
                        </div>
                    </div>
                    )
                })
            }
        
        </div>)
    }

    if (systems.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <Person />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                        Pin User
                    </h4>
                </CardHeader>
                <CardBody>This feature is unavailable for your account.</CardBody>
            </Card>
        );
    }

    return (
        <Card className='inviteUserForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Person />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Pin User</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()} disabled={!systems || !systems.length}>
                    <div style={{ width: '100%' }}>
                    <Autocomplete
                            options={accountOptions}
                            getOptionLabel={(account) => account}
                            id='account-name'
                            value={pickedAccount}
                            onChange={(event, newValue) => handlePickAccount(event, newValue)}
                            renderInput={(accounts) => <TextField {...accounts} label='Account' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                        <Autocomplete
                            options={systemOptions}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystems}
                            multiple={true}
                            disabled={!pickedAccount}
                            onChange={(e, newVal) => setPickedSystems(newVal)}
                            renderInput={(systemOptions) => <TextField {...systemOptions} label='Systems' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                        {renderNotificationSettings()}
                        {renderAccountRoleSettings()}
                    </div>
                </FormControl>
                {renderMobileNotifications()}
                {pinButton()}
            </CardBody>
            {!mobileView ? (
                <>
                    <Snackbar
                        close
                        closeNotification={() => closePinAccountNotification()}
                        color={pinAccountFailed ? 'danger' : 'success'}
                        message={pinAccountFailed ? 'Could not pin user to account.' : 'User pinned successfully.'}
                        open={pinAccountFailed || (pinAccountSucceeded && !createAccountSucceeded)}
                        place='tc'
                    />
                </>
            ) : null}
        </Card>
    );
};

const mapStateToProps = (state) => ({
    accounts: state.dashboard.accounts,
    nodes: state.dashboard.nodes,
    FreeSystems: state.dashboard.FreeSystems,
    pinAccountFailed: state.dashboard.pinAccountFailed,
    pinAccountSucceeded: state.dashboard.pinAccountSucceeded,
    createAccountSucceeded: state.dashboard.createAccountSucceeded,
    emptySystem: state.dashboard.emptySystem,
    mobileView: state.dashboard.mobileView
});
const actions = {
    getVisibleSystemsForAccountShort,
    pinUserToSystems,
};

const PinUserWithStyles = regularFormsStyle(PinUser);
export default connect(mapStateToProps, actions)(PinUserWithStyles);
